import { api } from '../apiClient';

export type GlobalSearchResults = {
  clients: Array<{ id: string; name: string; stage: string | null }>;
  tickets: Array<{ id: number; title: string; status: string; thread_id: number | null }>;
  meetings: Array<{ id: string; title: string; meeting_date: string }>;
  leads: Array<{ id: number; name: string; contact_name: string | null }>;
  /** Roadmap 17h (2026-09-18): the palette searches crm_contacts by name, company, email and phone digits. */
  contacts?: Array<{ id: number; name: string; company_name: string | null; email: string | null; phone: string | null }>;
};

export const searchApi = {
  search: async (q: string): Promise<GlobalSearchResults> => {
    const r = await api.get('/search', { params: { q } });
    return r.data.data;
  },
};
